import React from 'react';
import styled from 'styled-components';
import {SocialIcon} from 'react-social-icons';

const SocialWrapper = styled.div`
    margin: 0 auto;
    display: flex;
    
    > div {
        padding: 0.5rem;
    }
`;

const SocialButtons = (props) => {
    const items = props.urls.map(url =>
        <div key={url} className="social-buttons__button"><SocialIcon url={url}/></div>
    );

    return (<SocialWrapper className="social-buttons__wrapper">
        {items}
    </SocialWrapper>)
};


export default SocialButtons;
